/**
 * @version 1.0.1
 * @author wuwg  <wuwg@thunisoft.com>
 * @createTime:2019-08-13,
 * @updateTime:2019-08-13
 * @copyright thunisoft fd
 * @description  *  [jsDoc中文文档]{@link  http://www.dba.cn/book/jsdoc/JSDOCKuaiBiaoQianBLOCKTAGS/CONSTRUCTS.html}
 *  [jsdoc-vuejs]{@link  http://npm.taobao.org/package/jsdoc-vuejs}  -
 *  [个人博客]{@link  http://www.wuweigang.com}
 */
import ccTab from '@/components/common/tab/index.vue';

export default {
    name: 'xq',
    components: {ccTab},
    data() {
        return {
            data:{
                cbxx:[
                    {name:'扣押船名', value:'bdwmc'},
                    {name:'船籍国', value:'cgjgbmTranslateText'},
                    {name:'执行案号', value:'ah'},
                    {name:'扣押理由', value:'kyly'},
                    {name:'扣押地点', value:'kydd'},
                    {name:'申请人', value:'sqr'},
                    {name:'被申请人', value:'bsrq'},
                    {name:'保全标的额（元）', value:'bqbde'},
                    {name:'扣押日期', value:'kyrq'},
                    {name:'发布日期', value:'fbsj'},
                    {name:'发布法院', value:'fbdwTranslateText'},
                    {name:'解扣日期', value:'jkrq'}
                ],
                qtxx:[
                    {name:'扣押标的物名', value:'bdwmc'},
                    {name:'执行案号', value:'ah'},
                    {name:'扣押理由', value:'kyly'},
                    {name:'扣押地点', value:'kydd'},
                    {name:'申请人', value:'sqr'},
                    {name:'被申请人', value:'bsrq'},
                    {name:'保全标的额（元）', value:'bqbde'},
                    {name:'扣押日期', value:'kyrq'},
                    {name:'发布日期', value:'fbsj'},
                    {name:'发布法院', value:'fbdwTranslateText'},
                    {name:'解扣日期', value:'jkrq'}
                ],
                xgfj:[]
            },
            kyxx: {},
            imgIndex:0,
            activeFirst:0,
            bh:'',
            bdlb:'',
            lx:''
        };
    },
    computed:{
        marginLeft() {
            return `-${this.activeFirst * 148}px`;
        }
    },
    created() {
        this.bh = this.$route.query.bh;
        this.lx = this.$route.query.lx;
        this.bdlb = this.$route.query.bdlb;
        this.init(this.bh);
        this.getFj();
    },
    methods: {
        // 初始化数据
        init(bh) {
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.kypm.kyxq.replace('{id}', bh)
            }).then((res) => {
                this.kyxx = res.data;
                this.kyxx.fbsj = this.kyxx.fbsj.replace(/T.*/g, '');
                const bqbde = this.kyxx.bqbde.toString();
                if (bqbde.indexOf('.') === -1) {
                    this.kyxx.bqbde = `${bqbde}.00`;
                } else {
                    // 根据小数点拆分
                    let bqbdeList = [];
                    bqbdeList = bqbde.split('.');
                    if (bqbdeList[1].length === 1) {
                        this.kyxx.bqbde = `${bqbde}0`;
                    }
                }
            });
        },
        // 获取附件列表
        getFj() {
            window.fdGlobal.ajax({
                methods: window.fdConfig.methodGet,
                url: window.fdConfig.url.common.getFile,
                params: {businessId: this.bh, type: this.lx}
            }).then((res) => {
                if (res.data.length) {
                    res.data.forEach(e => {
                        const zc = {
                            name: e.wjmc,
                            url: e.bh
                        };
                        this.data.xgfj.push(zc);
                    });
                }
            });
        },
        // 下载附件
        downLoadFile(item) {
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.common.downloadFile.replace('{id}', item.url),
                contentType: 'application/json;charset=utf-8',
                responseType: 'blob'
            }).then((res) => {
                const binaryData = [];
                const template = res.data;
                binaryData.push(template);
                const blob = new Blob(binaryData);
                // 非IE下载
                if ('download' in document.createElement('a')) {
                    const elink = document.createElement('a');
                    elink.download = item.name;
                    elink.style.display = 'none';
                    elink.href = URL.createObjectURL(blob);
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href);
                    // 释放URL 对象
                    document.body.removeChild(elink);
                } else {
                    // IE10+下载
                    navigator.msSaveBlob(blob, item.name);
                }
            });
        }
    }
};

